import moment from "moment";
import { combineEpics, ofType } from "redux-observable";
import { map, switchMap, filter, take } from "rxjs/operators";
import { of } from "rxjs";
import JobProApi from "../../dependencies/JobProApi";
import {
  CALENDAR_FETCH,
  CALENDAR_UPDATE,
  CALENDAR_UPDATE_APPT,
} from "../calendar";

const CREW_FIELDS =
  "id,equipment(id,color,displayOrder,name,workCapacities(capacityType,value)),resources(resource(id,firstName,lastName,offices(id),calendarColor),resourcePercentage)";
const JOB_FIELDS =
  "id,address(city,line1,line2,state,zip),capacities(estimatedDuration,laborAmount,materialQuantity),contacts(isPrimaryContact,name,firstName,lastName,cellPhone,workPhone,email),customer(id,name),estimatedStartDate,items(item(itemType(id,name,estimatedQuantityLabel)),proposedQuantity,estimatedQuantity),geoPoint(latitude,longitude),jobNumber,jobTotal,jobType,location,office(id,name),name,profit(actualProfit,proposedProfit),salesperson(calendarColor,firstName,lastName),status,priorityNotes";
const CALENDAR_FIELDS = `id,crew(${CREW_FIELDS}),description,displayOrder,endDate,endTime,job(${JOB_FIELDS}),startDate,startTime,customer(id,name),datasheet(id,name),appttype`;
const PURCHASE_ORDER_FIELDS = `id,crew(${CREW_FIELDS}),dateDelivered,deliveryOrder,items(id,item(id,itemType(id,inventoryQuantityLabel,name),name),job(id,geoPoint(latitude,longitude),jobNumber,name),quantity,summary),loadCapacity,name,office(id,name),poNumber,shipTo,status(name),supplier(name)`;
const INVENTORY_PURCHASE_ORDER_FIELDS = `id,crew(${CREW_FIELDS}),dateDelivered,deliveryOrder,items(id,item(id,itemType(id,inventoryQuantityLabel,name),name),job(id,geoPoint(latitude,longitude),jobNumber,name),quantity,summary),loadCapacity,name,office(id,name),poNumber,shipTo,status,supplier(name)`;

const CALENDAR_EVENTS_QUERY = `
query Scheduler($bidCriteria: BidCriteria, $calendarCriteria: CalendarEventCriteria, $jobCriteria: JobCriteria, $poCriteria: PurchaseOrderCriteria, $invPoCriteria: InventoryPurchaseOrderCriteria){
  calendarEvents(filter: $calendarCriteria, limit: 999999) {
    id
    crewId
    crew {
      ...crewFields
    }
    description
    displayOrder
    endDate
    endTime
    jobId
    job {
      ...jobFields
    }
    startDate
    startTime  
    datasheetId  
    datasheet{
      id
      name      
      customer {
        id
        name
        address {
          city
          line1
          line2
          state
          zip
        }
        status
        phonenumber
        salesperson {
          id
          calendarColor
          firstName
          lastName
        }
      }
      status  
      salesperson {
        id
        calendarColor
        firstName
        lastName
      }   
      office {
        id
        name
      }
      
    }
    customer {
      id
      name
      address {
        city
        line1
        line2
        state
        zip
      }
      status
      phonenumber
      salesperson {
        id
        calendarColor
        firstName
        lastName
      }
    }
    appttype
  }

  bids(filter: $bidCriteria, limit: 999999) {
    ...bidFields
  }

  jobs(filter: $jobCriteria, limit: 999999) {
    ...jobFields
  }

  purchaseOrders(filter: $poCriteria, limit: 999999) {
    ...purchaseOrderFields
  }
  
  inventoryPurchaseOrders(filter: $invPoCriteria, limit: 999999) {
    ...inventoryPurchaseOrderFields
  }

}

fragment bidFields on Bid {
  address {
    city
    line1
    line2
    state
    zip
  }
  contacts {
    cellPhone
    email
    isPrimaryContact
    firstName
    name
    lastName
    workPhone
  }
  customer {
    id
    name
  }
  estimatedStartDate
  id
  name
  office {
    id
    name
  }
  priorityNotes
  salesperson {
    id
    calendarColor
    firstName
    lastName
  }
  status {
    name
  }
}

fragment crewFields on Crew {
  id
  equipment {
    color
    displayOrder
    id
    name
    workCapacities {
      capacityType
      value
    }
  }
  resources {
    resource {
      id
      firstName
      lastName
      offices {
        id
      }
      calendarColor
    }
  }
}

fragment jobFields on Job {
  address {
    city
    line1
    line2
    state
    zip
  }
  capacities {
    estimatedDuration
    laborAmount
    materialQuantity
  }
  contacts {
    cellPhone
    email
    isPrimaryContact
    firstName
    name
    lastName
    workPhone
  }
  customer {
    id
    name
  }
  estimatedStartDate
  geoPoint {
    latitude
    longitude
  }
  id
  items {
    item {
      itemType {
        id
        name
        estimatedQuantityLabel
      }
    }
    proposedQuantity
    estimatedQuantity
  }
  jobNumber
  jobTotal
  jobType
  location
  name
  office {
    id
    name
  }
  profit {
    actualProfit
    proposedProfit
  }
  salesperson {
    id
    calendarColor
    firstName
    lastName
  }
  status
  priorityNotes
}

fragment purchaseOrderFields on PurchaseOrder {
  id
  crew {
    ...crewFields
  }
  dateDelivered
  deliveryOrder
  items {
    id
    item {
      id
      itemType {
        id
        inventoryQuantityLabel
        name
      }
      name
      packagingAlternates {
        item: sourceItem {
          id
          itemType {
            id
            inventoryQuantityLabel
            name
          }
          name
        }
        yield
      }
    }
    job {
      id
      geoPoint {
        latitude
        longitude
      }
      jobNumber
      name
    }
    quantity
    summary
  }
  loadCapacity
  name
  office {
    id
    name
  }
  poNumber
  shipTo
  status {
    name
  }
  supplier {
    name
  }
}

fragment inventoryPurchaseOrderFields on Inventory_PurchaseOrder {
  iD
  crew {
    ...crewFields
  }
  dateDelivered
  deliveryOrder
  items {
    iD
    item {
      id
      itemType {
        id
        inventoryQuantityLabel
        name
      }
      name
      packagingAlternates {
        item: sourceItem {
          id
          itemType {
            id
            inventoryQuantityLabel
            name
          }
          name
        }
        yield
      }
    }
    job {
      id
      geoPoint {
        latitude
        longitude
      }
      jobNumber
      name
    }
    quantity
    notes
  }
  loadCapacity
  name
  office {
    id
    name
  }
  poNumber
  shipTo
  status
  supplier {
    name
  }
}
`;

const NON_INVENTORY_CALENDAR_EVENTS_QUERY = `
query Scheduler($bidCriteria: BidCriteria, $calendarCriteria: CalendarEventCriteria, $jobCriteria: JobCriteria, $poCriteria: PurchaseOrderCriteria){
  calendarEvents(filter: $calendarCriteria, limit: 999999) {
    id
    crewId
    crew {
      ...crewFields
    }
    description
    displayOrder
    endDate
    endTime
    jobId
    job {
      ...jobFields
    }
    startDate
    startTime  
    datasheetId  
    datasheet{
      id
      name      
      customer {
        id
        name
        address {
          city
          line1
          line2
          state
          zip
        }
        status
        phonenumber
        salesperson {
          id
          calendarColor
          firstName
          lastName
        }
      }
      status  
      salesperson {
        id
        calendarColor
        firstName
        lastName
      }   
      office {
        id
        name
      }
      
    }
    customer {
      id
      name
      address {
        city
        line1
        line2
        state
        zip
      }
      status
      phonenumber
      salesperson {
        id
        calendarColor
        firstName
        lastName
      }
    }
    appttype
  }

  bids(filter: $bidCriteria, limit: 999999) {
    ...bidFields
  }

  jobs(filter: $jobCriteria, limit: 999999) {
    ...jobFields
  }

  purchaseOrders(filter: $poCriteria, limit: 999999) {
    ...purchaseOrderFields
  }

}

fragment bidFields on Bid {
  address {
    city
    line1
    line2
    state
    zip
  }
  contacts {
    cellPhone
    email
    isPrimaryContact
    firstName
    name
    lastName
    workPhone
  }
  customer {
    id
    name
  }
  estimatedStartDate
  id
  name
  office {
    id
    name
  }
  priorityNotes
  salesperson {
    id
    calendarColor
    firstName
    lastName
  }
  status {
    name
  }
}

fragment crewFields on Crew {
  id
  equipment {
    color
    displayOrder
    id
    name
    workCapacities {
      capacityType
      value
    }
  }
  resources {
    resource {
      id
      firstName
      lastName
      offices {
        id
      }
      calendarColor
    }
  }
}

fragment jobFields on Job {
  address {
    city
    line1
    line2
    state
    zip
  }
  capacities {
    estimatedDuration
    laborAmount
    materialQuantity
  }
  contacts {
    cellPhone
    email
    isPrimaryContact
    firstName
    name
    lastName
    workPhone
  }
  customer {
    id
    name
  }
  estimatedStartDate
  geoPoint {
    latitude
    longitude
  }
  id
  items {
    item {
      itemType {
        id
        name
        estimatedQuantityLabel
      }
    }
    proposedQuantity
    estimatedQuantity
  }
  jobNumber
  jobTotal
  jobType
  location
  name
  office {
    id
    name
  }
  profit {
    actualProfit
    proposedProfit
  }
  salesperson {
    id
    calendarColor
    firstName
    lastName
  }
  status
  priorityNotes
}

fragment purchaseOrderFields on PurchaseOrder {
  id
  crew {
    ...crewFields
  }
  dateDelivered
  deliveryOrder
  items {
    id
    item {
      id
      itemType {
        id
        inventoryQuantityLabel
        name
      }
      name
      packagingAlternates {
        item: sourceItem {
          id
          itemType {
            id
            inventoryQuantityLabel
            name
          }
          name
        }
        yield
      }
    }
    job {
      id
      geoPoint {
        latitude
        longitude
      }
      jobNumber
      name
    }
    quantity
    summary
  }
  loadCapacity
  name
  office {
    id
    name
  }
  poNumber
  shipTo
  status {
    name
  }
  supplier {
    name
  }
}
`;

// Action types
const FETCH_EVENTS_COMPLETE = "FETCH_EVENTS_COMPLETE";

const DEFAULT_STATE = {
  events: [],
  loading: false,
};

/**
 * Returns a function that can be passed to Array.filter.
 * Resulting function returns true if the event falls within the specified dates.
 * @param {moment} startDate
 * @param {moment} endDate
 * @return {function}
 */
const filterEventsBetween = (startDate, endDate) => (e) =>
  (startDate.isSame(e.endDate) || startDate.isBefore(e.endDate)) &&
  (endDate.isSame(e.startDate) || endDate.isAfter(e.startDate));

// Reducer
export default function (state = DEFAULT_STATE, { payload, type }) {
  switch (type) {
    case CALENDAR_FETCH:
      const rangeUnit = payload.mode === "dispatch" ? "day" : payload.mode;
      const startDate = moment(payload.date).startOf(rangeUnit);
      const endDate = moment(payload.date).endOf(rangeUnit);
      return {
        ...state,
        events: state.events.filter(filterEventsBetween(startDate, endDate)),
        loading: true,
      };
    case CALENDAR_UPDATE:
      return {
        ...state,
        loading: !!payload.loading,
        events: [
          ...state.events.filter(
            (e) => e.id !== payload.id && e.id !== payload.originalId
          ),
          payload,
        ],
      };
    case CALENDAR_UPDATE_APPT:
      return {
        ...state,
        loading: true,
        events: [...state.events, payload],
      };

    case FETCH_EVENTS_COMPLETE:
      return {
        ...state,
        ...payload,
        loading: false,
      };
    default:
      return state;
  }
}

/**
 * Action creator for FETCH_EVENTS_COMPLETE.
 *
 * @param {any} events
 */
const fetchEventsComplete = (events) => ({
  type: FETCH_EVENTS_COMPLETE,
  payload: { events },
});

const mapBidToEvent = (b) => ({
  id: `BID-${b.id}`,
  key: Math.random(),
  crew: null,
  startDate: b.estimatedStartDate,
  endDate: b.estimatedStartDate,
  bid: b,
  tentative: true,
  evttype: "bids",
});

const mapCalendarEventToEvent = (c) => ({
  ...c,
  key: Math.random(),
  evttype: c.job != null ? "jobs" : "appointments",
});

/**
 * Maps a purchase order to a calendar event like object.
 * @param {any} p
 */
const mapPurchaseOrderToEvent = (p) => ({
  id: `PO-${p.id}`,
  key: Math.random(),
  crew: p.crew,
  startDate: p.dateDelivered,
  endDate: p.dateDelivered,
  purchaseOrder: p,
  evttype: "purchaseOrders",
});

const mapInventoryPurchaseOrderToEvent = (p) => ({
  id: `IPO-${p.iD}`,
  key: Math.random(),
  crew: p.crew,
  startDate: p.dateDelivered,
  endDate: p.dateDelivered,
  inventoryPurchaseOrder: p,
  evttype: "purchaseOrders",
});

const mapTentativeJobToEvent = (j) => ({
  id: `JOB-${j.id}`,
  key: Math.random(),
  crew: null,
  startDate: j.estimatedStartDate,
  endDate: j.estimatedStartDate,
  job: j,
  tentative: true,
  evttype: "jobs",
});

/**
 * Subscribes to actions of type CALENDAR_FETCH.
 * Fetches calendar events dispatches the result.
 * @param {*} action$
 * @param {*} state$
 */
const fetchEventsEpic = (action$, state$) =>
  action$.pipe(
    ofType(CALENDAR_FETCH),
    map(({ payload }) => payload),
    switchMap(({ date, mode }) => {
      const { settings } = state$;

      const rangeUnit = mode === "dispatch" ? "day" : mode;
      const startDate = moment(date).startOf(rangeUnit);
      const endDate = moment(date).endOf(rangeUnit);

      // Build API filter criteria
      const criteria = {
        startDate: startDate.format("YYYY-MM-DD"),
        endDate: endDate.format("YYYY-MM-DD"),
      };
      if (settings.bidTypes && settings.bidTypes.length) {
        criteria["job.bid.category"] = settings.bidTypes.map((c) => c.value);
      }
      if (settings.jobStatuses && settings.jobStatuses.length) {
        criteria.jobStatus = settings.jobStatuses.map((s) => s.value);
      }
      if (settings.jobTypes && settings.jobTypes.length) {
        criteria.jobType = settings.jobTypes.map((t) => t.name);
      }
      if (settings.offices && settings.offices.length) {
        criteria.office = settings.offices.map((o) => o.name);
      }
      if (settings.salespeople && settings.salespeople.length) {
        criteria["job.salesperson.id"] = settings.salespeople.map((s) => s.id);
      }

      const calendarPromise = JobProApi.calendar.query(criteria, {
        fields: CALENDAR_FIELDS,
        limit: 999999,
      });

      const purchaseOrderCriteria = {
        "dateDelivered>": startDate.format("YYYY-MM-DD"),
        "dateDelivered<": endDate.format("YYYY-MM-DD"),
      };
      if (settings.offices && settings.offices.length) {
        purchaseOrderCriteria["office.id"] = settings.offices.map((o) => o.id);
      }
      const purchaseOrderPromise = JobProApi.purchaseOrders.search(
        purchaseOrderCriteria,
        {
          fields: PURCHASE_ORDER_FIELDS,
          limit: 999999,
        }
      );

      const tentativeJobsCriteria = {
        "estimatedStartDate>": startDate.format("YYYY-MM-DD"),
        "estimatedStartDate<": endDate.format("YYYY-MM-DD"),
        scheduled: false,
      };
      if (settings.bidTypes && settings.bidTypes.length) {
        tentativeJobsCriteria["bid.category"] = settings.bidTypes.map(
          (c) => c.value
        );
      }
      if (settings.jobStatuses && settings.jobStatuses.length) {
        tentativeJobsCriteria.status = settings.jobStatuses.map((s) => s.value);
      }
      if (settings.jobTypes && settings.jobTypes.length) {
        tentativeJobsCriteria.type = settings.jobTypes.map((t) => t.name);
      }
      if (settings.offices && settings.offices.length) {
        tentativeJobsCriteria.office = settings.offices.map((o) => o.name);
      }
      if (settings.salespeople && settings.salespeople.length) {
        tentativeJobsCriteria["salesperson.id"] = settings.salespeople.map(
          (s) => s.id
        );
      }
      const tentativeJobsPromise = JobProApi.jobs.search(
        tentativeJobsCriteria,
        {
          fields: JOB_FIELDS,
          limit: 999999,
        }
      );

      return Promise.all([
        calendarPromise,
        purchaseOrderPromise,
        tentativeJobsPromise,
      ]).then(([calendar, purchaseOrders, tentativeJobsPromise]) => [
        ...calendar.map(mapCalendarEventToEvent),
        ...purchaseOrders.map(mapPurchaseOrderToEvent),
        ...tentativeJobsPromise.map(mapTentativeJobToEvent),
      ]);
    }),
    map(fetchEventsComplete)
  );

/**
 * Subscribes to actions of type CALENDAR_FETCH.
 * Fetches calendar events dispatches the result.
 * @param {*} action$
 * @param {*} state$
 */
const fetchEventsEpicGraphQL = (action$, state$) =>
  action$.pipe(
    ofType(CALENDAR_FETCH),
    map(({ payload }) => payload),
    switchMap(({ date, mode }) => {
      if (state$.value.tokenInfo?.loading) {
        return state$.pipe(
          filter((state) => !state.tokenInfo.loading),
          take(1),
          map(() => ({ date, mode }))
        );
      }

      return of({ date, mode });
    }),
    switchMap(({ date, mode }) => {
      const { settings, tokenInfo } = state$.value;

      const hasInventoryScope =
        tokenInfo?.scope?.split(" ").includes("inventory:on") || false;

      const rangeUnit = mode === "dispatch" ? "day" : mode;
      const startDate = moment(date).startOf(rangeUnit);
      const endDate = moment(date).endOf(rangeUnit);
      // Build API filter criteria
      const criteria = {
        endDate_gte: startDate.format("YYYY-MM-DD"),
        startDate_lte: endDate.format("YYYY-MM-DD"),
        job: {},
        datasheet: {},
        customer: {},
      };
      if (settings.bidTypes && settings.bidTypes.length) {
        criteria.job.bid = {
          bidType_in: settings.bidTypes.map((c) => c.value),
        };
      }
      if (settings.jobStatuses && settings.jobStatuses.length) {
        criteria.job.status_in = settings.jobStatuses.map((s) => s.value);
      }
      if (settings.jobTypes && settings.jobTypes.length) {
        criteria.job.jobType_in = settings.jobTypes.map((t) => t.name);
      }
      if (settings.offices && settings.offices.length) {
        if (settings.entity !== "appointments") {
          criteria.job.office = {
            id_in: settings.offices.map((o) => o.id),
          };
        } else if (settings.entity === "appointments") {
          criteria.datasheet.office = {
            id_in: settings.offices.map((o) => o.id),
          };
        }
      }
      if (settings.salespeople && settings.salespeople.length) {
        if (settings.entity != "appointments") {
          criteria.job.salesperson = {
            id_in: settings.salespeople.map((s) => s.id),
          };
        } else if (settings.entity === "appointments") {
          criteria.datasheet.salesperson = {
            id_in: settings.salespeople.map((s) => s.id),
          };
        }
      }

      const purchaseOrderCriteria = {
        dateDelivered_gte: startDate.format("YYYY-MM-DD"),
        dateDelivered_lte: endDate.format("YYYY-MM-DD"),
      };

      const inventoryPurchaseOrderCriteria = {
        dateDelivered_gte: startDate.format("YYYY-MM-DD"),
        dateDelivered_lte: endDate.format("YYYY-MM-DD"),
      };

      if (settings.offices && settings.offices.length) {
        purchaseOrderCriteria.office = {
          id_in: settings.offices.map((o) => o.id),
        };
        if (hasInventoryScope) {
          inventoryPurchaseOrderCriteria.office = {
            id_in: settings.offices.map((o) => o.id),
          };
        }
      }

      const tentativeJobsCriteria = {
        calendarEvents_none: {},
        estimatedStartDate_gte: startDate.format("YYYY-MM-DD"),
        estimatedStartDate_lte: endDate.format("YYYY-MM-DD"),
      };
      if (settings.bidTypes && settings.bidTypes.length) {
        tentativeJobsCriteria.bid = {
          bidType_in: settings.bidTypes.map((c) => c.value),
        };
      }
      if (settings.jobStatuses && settings.jobStatuses.length) {
        tentativeJobsCriteria.status_in = settings.jobStatuses.map(
          (s) => s.value
        );
      }
      if (settings.jobTypes && settings.jobTypes.length) {
        tentativeJobsCriteria.jobType_in = settings.jobTypes.map((t) => t.name);
      }
      if (settings.offices && settings.offices.length) {
        tentativeJobsCriteria.office = {
          id_in: settings.offices.map((o) => o.id),
        };
      }
      if (settings.salespeople && settings.salespeople.length) {
        tentativeJobsCriteria.salesperson = {
          id_in: settings.salespeople.map((s) => s.id),
        };
      }

      const bidCriteria = {
        jobs_none: {},
        estimatedStartDate_gte: startDate.format("YYYY-MM-DD"),
        estimatedStartDate_lte: endDate.format("YYYY-MM-DD"),
      };
      if (settings.bidTypes && settings.bidTypes.length) {
        bidCriteria.bidType_in = settings.bidTypes.map((c) => c.value);
      }
      if (settings.offices && settings.offices.length) {
        bidCriteria.office = {
          id_in: settings.offices.map((o) => o.id),
        };
      }
      if (settings.salespeople && settings.salespeople.length) {
        bidCriteria.salesperson = {
          id_in: settings.salespeople.map((s) => s.id),
        };
      }

      const graphQLPromise = JobProApi.post("/graphql", null, {
        query: hasInventoryScope
          ? CALENDAR_EVENTS_QUERY
          : NON_INVENTORY_CALENDAR_EVENTS_QUERY,
        variables: {
          bidCriteria,
          calendarCriteria: criteria,
          jobCriteria: tentativeJobsCriteria,
          poCriteria: purchaseOrderCriteria,
          ...(hasInventoryScope && {
            invPoCriteria: inventoryPurchaseOrderCriteria,
          }),
        },
      });

      const bidPromise = graphQLPromise.then((response) => response.data.bids);

      const calendarPromise = graphQLPromise.then((response) =>
        response.data.calendarEvents
          .filter((e) => (e.jobId != null && e.job == null ? false : true))
          .filter((e) => (e.crewId != null && e.crew == null ? false : true))
          .filter((e) =>
            e.datasheetId != null && e.datasheet == null ? false : true
          )
      );

      const purchaseOrderPromise = graphQLPromise.then(
        (response) => response.data.purchaseOrders
      );

      if (hasInventoryScope) {
        const inventoryPurchaseOrderPromise = graphQLPromise.then(
          (response) => response.data.inventoryPurchaseOrders
        );
      }

      const tentativeJobsPromise = graphQLPromise.then(
        (response) => response.data.jobs
      );

      const promises = [
        bidPromise,
        calendarPromise,
        purchaseOrderPromise,
        tentativeJobsPromise,
      ];

      if (hasInventoryScope) {
        const inventoryPurchaseOrderPromise = graphQLPromise.then(
          (response) => response.data.inventoryPurchaseOrders
        );
        promises.splice(3, 0, inventoryPurchaseOrderPromise); // Insert at index 3
      }

      return Promise.all(promises).then((results) => {
        const [bids, calendar, purchaseOrders, ...rest] = results;

        let inventoryPurchaseOrders = [];
        let tentativeJobs = rest[rest.length - 1]; // Last item is always tentative jobs

        if (hasInventoryScope) {
          inventoryPurchaseOrders = rest[0]; // First item in rest array
        }

        return [
          ...bids.map(mapBidToEvent),
          ...calendar.map(mapCalendarEventToEvent),
          ...purchaseOrders.map(mapPurchaseOrderToEvent),
          ...(hasInventoryScope
            ? inventoryPurchaseOrders.map(mapInventoryPurchaseOrderToEvent)
            : []),
          ...tentativeJobs.map(mapTentativeJobToEvent),
        ];
      });
    }),
    map(fetchEventsComplete)
  );

export const epic = combineEpics(
  location.search.match(/graphql=false/)
    ? fetchEventsEpic
    : fetchEventsEpicGraphQL
);

// Selectors
export * from "./selectors";
